var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1744478926095,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7462,
    width: 256,
    height: 256,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M873.767394 852.441693",
    fill: "#4C86E2",
    "p-id": 7463
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.567371 64.413032c-247.00565 0-447.24416 200.236464-447.24416 447.24416S263.560698 958.902376 510.567371 958.902376c94.481861 0 182.116781-29.296233 254.322289-79.300091-0.151449-0.054235-0.293689-0.11768-0.445138-0.171915 7.319709-5.901407 12.010545-14.936177 12.010545-25.069979 0-17.774829-14.404058-32.178887-32.17991-32.178887-9.717316 0-18.424628 4.314259-24.327058 11.124362-0.01535-0.054235-0.038886-0.102331-0.054235-0.156566-60.0824 39.025828-131.771139 61.701271-208.753441 61.701271-211.946157 0-383.761314-171.817204-383.761314-383.76643 0-211.94411 171.816181-383.761314 383.761314-383.761314 211.94411 0 383.760291 171.817204 383.760291 383.761314 0 87.044472-28.984125 167.316703-77.819366 231.699036-6.610558 5.892197-10.778484 14.473643-10.778484 24.02416 0 17.770735 14.404058 32.17991 32.17991 32.17991 8.271384 0 15.815197-3.127224 21.518083-8.258081 0.005117 0.024559 0.01535 0.044002 0.01842 0.068562 0.083911-0.102331 0.161682-0.204661 0.245593-0.308015 2.62785-2.424212 4.856611-5.27719 6.566556-8.452509 57.082066-75.097372 90.982154-168.775938 90.982154-270.381034C957.812555 264.649496 757.574045 64.413032 510.567371 64.413032z",
    fill: "#4C86E2",
    "p-id": 7464
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.899702 638.201284 490.980267 762.180969 490.980267 519.241938 284.899702 395.258159Z",
    fill: "#4C86E2",
    "p-id": 7465
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.383532 260.072247 310.031079 360.600825 511.162936 487.178685 712.290699 383.848295Z",
    fill: "#4C86E2",
    "p-id": 7466
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M533.799492 518.124488 533.799492 761.063519 735.00298 657.734152 735.007073 657.734152 735.007073 414.795121Z",
    fill: "#4C86E2",
    "p-id": 7467
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProduct);
export default __webpack_public_path__ + "static/media/default-product.e9fb4c7dee7b22edfa86e1821ac47dbd.svg";
export { ForwardRef as ReactComponent };